import { Divider } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Link from '@material-ui/core/Link';
import Popover from '@material-ui/core/Popover';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  DASHBOARD,
  EDITOR_HOST,
  PROFILE,
  SIGN_IN,
  SIGN_OUT
} from '../../links';
import SignIn from '../icons/sign-in';

const useStyles = makeStyles(theme => ({
  buttonsWrap: {
    [theme.breakpoints.up('md')]: {
      flex: '0 0 auto',
      display: 'flex'
    }
  },
  button: {
    padding: theme.spacing(3, 5),
    marginRight: theme.spacing(2),
    '&:last-of-type': {
      marginRight: 0
    }
  },
  gutter: {
    padding: theme.spacing(4, 2)
  },
  profile: {
    display: 'flex',
    alignItems: 'center'
  },
  popover: {},
  profileIcon: {
    marginLeft: theme.spacing(2)
  },
  profileContent: {
    minWidth: 156,
    width: '100%'
  },
  profileName: {
    marginBottom: theme.spacing(4),
    fontSize: 14,
    lineHeight: '19px',
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#324D59'
  },
  profileButton: {
    fontWeight: 'bold',
    minHeight: 40
  },
  underline: {
    textDecoration: 'underline'
  },
  logOutButton: {
    textDecoration: 'none',
    color: theme.palette.text.primary,

    '&:hover': {
      textDecoration: 'none'
    }
  }
}));

const HeaderButtons = ({ isColor, user, isAuthenticated }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { t } = useTranslation();
  const theme = useTheme();

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'profile-menu-popover' : undefined;

  if (isAuthenticated) {
    return (
      <>
        <div className={classes.profile}>
          <Button
            variant="outlined"
            className={classes.button}
            href={EDITOR_HOST}
            fullWidth
            color={isColor ? 'inherit' : 'primary'}
          >
            {t('headerMenu.Create_AR')}
          </Button>
          <IconButton
            aria-describedby={id}
            variant="text"
            onClick={handleClick}
            className={classes.profileIcon}
          >
            <SignIn
              textColor={
                isColor
                  ? theme.palette.common.white
                  : theme.palette.primary.main
              }
            />
          </IconButton>
        </div>
        <Popover
          className={classes.popover}
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center'
          }}
        >
          <div className={classes.profileContent}>
            <Button
              component={Link}
              className={clsx(classes.profileButton, classes.underline)}
              variant="text"
              href={DASHBOARD}
              fullWidth
              color="primary"
            >
              Dashboard
            </Button>
            <Divider />
            <Button
              component={Link}
              className={clsx(classes.profileButton, classes.underline)}
              variant="text"
              href={PROFILE}
              fullWidth
              color="primary"
            >
              Profile
            </Button>
            <Divider />
            <Button
              component={Link}
              className={clsx(classes.profileButton, classes.logOutButton)}
              variant="text"
              fullWidth
              color="secondary"
              href={SIGN_OUT}
            >
              Log out
            </Button>
          </div>
        </Popover>
      </>
    );
  }

  return (
    <div className={classes.buttonsWrap}>
      <Button
        variant="outlined"
        className={classes.button}
        href={SIGN_IN}
        color={isColor ? 'inherit' : 'primary'}
      >
        {t('headerMenu.Create_AR')}
      </Button>
      <Button
        variant="outlined"
        className={classes.button}
        href={SIGN_IN}
        color={isColor ? 'inherit' : 'primary'}
        startIcon={
          <SignIn
            textColor={
              isColor ? theme.palette.common.white : theme.palette.primary.main
            }
          />
        }
      >
        {t('headerMenu.Sign_in')}
      </Button>
    </div>
  );
};

HeaderButtons.propTypes = {
  // eslint-disable-next-line react/require-default-props
  user: PropTypes.shape({
    id: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string
  }),
  isColor: PropTypes.bool
};

HeaderButtons.defaultProps = {
  isColor: false
};

export default HeaderButtons;
